import { render, staticRenderFns } from "./sendPripMail.vue?vue&type=template&id=e04cc6fe&scoped=true"
import script from "./sendPripMail.vue?vue&type=script&lang=js"
export * from "./sendPripMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04cc6fe",
  null
  
)

export default component.exports